<template>
  <div class="user-card">
    <div class="image" v-if="user.avatar"><img :src="proxy(user.avatar)"></div>
    <div class="user-info">
      <div class="username" @click="viewProfile(user.userName)" v-line-clamp="2">
        {{name}}
        <span v-if="user.isEngStaff" class="staff-shield"><i class="fal fa-shield-check"></i></span>
      </div>
      <html-view class="blurb" v-if="blurb" v-line-clamp="3" ref="htmlView" :content="blurb"></html-view>

      <li class="interests" v-if="interests">
        <ul v-for="interest in interests" :key="interest.name" v-line-clamp="1">{{ interest.name }}</ul>
      </li>
    </div>
  </div>
</template>

<script>
import imageProxy from '@/libs/image-proxy'
import HtmlView from '@/components/Controls/HTMLView'
import Vue from 'vue'
import lineClamp from 'vue-line-clamp'

Vue.use(lineClamp, {
  textOverflow: 'ellipsis'
})

export default {
  components: {
    HtmlView
  },
  props: ['user', 'roles'],
  data: function () {
    return {
      defaultInterests: [{ key: 1, name: 'Projects' }, { key: 2, name: 'Engineering' }, { key: 3, name: 'Innovation' }], // Better ones?
      blurb: '',
      interests: []
    }
  },
  created: function () {
    this.fetchBlurb()
    this.fetchInterests()
  },
  computed: {
    name: function () {
      return this.user.fullName ? this.user.fullName : this.user.userName
    }
  },
  methods: {
    proxy: function (src) {
      return imageProxy.proxy(src, { width: 200, height: 200 })
    },
    viewProfile: function (username) {
      this.$router.push({ name: 'profile', params: { username } })
    },
    randomMessage: function () {
      return this.user.userName + ' hasn’t added a summary to their profile yet'
    },
    fetchBlurb: function () {
      this.$store.dispatch('getProfile', this.user.userName).then((user) => {
        this.blurb = user.intro || user.bio || user.location || this.randomMessage()
      })
    },
    fetchInterests: function () {
      this.$store.dispatch('getProfile', this.user.userName).then((user) => {
        if (user.interests.length > 0) {
          this.interests = user.interests
        } else if (user.skills.length > 0) {
          this.interests = user.skills
        } else {
          this.interests = this.defaultInterests
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  .user-card {
    width: 90%;
    position: relative;
    margin-bottom: 20px;
    height: 380px;
    overflow: visible;
    @include mobile {
      padding: 10px;
      width: 90%;
    }

    .image {
      z-index: 2;
      margin: 0 auto;
      width: 100%;

      overflow:hidden;
      position:absolute;

      img {
        width: 7rem;
        height: 7rem;
        min-width: 7rem;
        max-width: 7rem;
        min-height: 7rem;
        max-height: 7rem;
        margin: 0 auto;
        border-radius: 50%;
        &:hover {
          width: 8rem;
          height: 8rem;
          min-width: 8rem;
          max-width: 8rem;
          min-height: 8rem;
          max-height: 8rem;
          margin: 0 auto;
        }
      }
    }

    .user-info {
      z-index: 1;
      top: 80px;
      width: 100%;
      padding: 50px 10px 10px;
      height: 300px;
      min-height: 300px;
      max-height: 300px;
      background-color: #F6F6F6;
      position: absolute;
      -webkit-box-shadow: 0px 2px 4px 0px #CECECE;
      -moz-box-shadow: 0px 2px 4px 0px #CECECE;
      box-shadow: 0px 2px 4px 0px #CECECE;

      .username {
        font-weight: bold;
        font-size: 1.5rem;
        hyphens: auto;
        height: 80px;
        justify-content: center;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        word-break: break-word !important;
        @include mobile-and-ipad {
          font-size: 1rem;
          height: 58px;
          word-break: break-all;
        }
      }
      .blurb {
        word-break: keep-all !important;
        font-size: 14px;
        text-align: left;
      }
      .interests {
        display: inline-flex;
        flex-flow: wrap;
        overflow: hidden;
        padding-top: 20px;
        font-size: 12px;
        max-height: 100px; // Only display first two rows of interests/skills
        text-overflow: clip;
        ul {
          background-color: white;
          padding: 5px;
          border-radius: 5px;
          margin: 5px;
        }
      }
    }

    .role{
      font-size: 0.7rem;
      color: $grey;
    }
  }
</style>
